import React, { useState } from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';

import SrText from 'client/components/SrText';
import SrBox from 'client/components/SrBox';
import SrPartnerTaskListRow from 'client/components/SrPartnerTaskList/SrPartnerTaskListRow';

const SrPartnerTaskListSection = ({
  title,
  titleColor,
  rowColorHex,
  borderColorHex,
  currentUser,
  partnerTaskList,
  updatePartnerTask,
  showListingAddress,
  expandLabel,
}) => {
  const shouldShowExpandCta = !!expandLabel && partnerTaskList.length > 3;
  const [isExpanded, setIsExpanded] = useState(!shouldShowExpandCta);
  return (
    <div>
      <SrBox paddingBottom="5px">
        <SrText color={titleColor} size="18" weight="600" paddingBottom="5px">
          {title}
        </SrText>
      </SrBox>
      {(isExpanded ? partnerTaskList : partnerTaskList.slice(0, 3)).map((task) => (
        <SrBox paddingTop="4px" key={task.id}>
          <SrPartnerTaskListRow
            task={task}
            updatePartnerTask={updatePartnerTask}
            rowColorHex={rowColorHex}
            borderColorHex={borderColorHex}
            currentUser={currentUser}
            showListingAddress={showListingAddress}
          />
        </SrBox>
      ))}
      {shouldShowExpandCta && (
        <SrBox paddingTop="10px" textAlign="center" onClick={() => setIsExpanded(!isExpanded)}>
          <SrText font="greycliff" cursor="pointer" weight="700" color="blue300" size="14">
            {`Show ${
              isExpanded ? 'less tasks' : `all ${pluralize('task', partnerTaskList.length, true)}`
            } ${expandLabel}`}
          </SrText>
        </SrBox>
      )}
    </div>
  );
};

SrPartnerTaskListSection.propTypes = {
  title: PropTypes.string.isRequired,
  titleColor: PropTypes.string,
  rowColorHex: PropTypes.string,
  borderColorHex: PropTypes.string,
  partnerTaskList: PropTypes.array.isRequired,
  updatePartnerTask: PropTypes.func,
  currentUser: PropTypes.object.isRequired,
  showListingAddress: PropTypes.bool,
  expandLabel: PropTypes.string,
};

SrPartnerTaskListSection.displayName = 'SrPartnerTaskListSection';

export default SrPartnerTaskListSection;
